"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Track = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Track = styled_components_1.default.div.attrs(({ getTrackProps }) => getTrackProps())({
    position: 'absolute',
    height: '3px',
    top: '13px',
    borderRadius: '3px',
    cursor: 'pointer',
}, ({ disabled = false, source, target, theme: { colors } }) => ({
    backgroundColor: disabled ? 'rgba(153,153,153,0.47)' : colors.primary,
    left: `${source.percent}%`,
    width: `${target.percent - source.percent}%`,
}));
//# sourceMappingURL=Track.js.map